import { useSelector } from 'react-redux';
import { RootState } from '@v2/store';

export function useFormState(formId: string) {
    return useSelector((state: RootState) => state.form.data[formId] || {});
}


export function useIsFormExists(formId: string) {
    return useSelector((state: RootState) => !!state.form.data[formId]);
}